// extracted by mini-css-extract-plugin
export default {"tableContainer":"style_tableContainer__4YwBy","dataTable":"style_dataTable__iRpc1"};